import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Form, FormResponse } from '../../models/forms.model';

export interface FormsState {
  formsMap: Record<number, Form[]>;
  currentForm: Form | null;
}

const initialState: FormsState = {
  formsMap: {},
  currentForm: null,
};

const formsSlice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    setForms(state, action: PayloadAction<{ communityId: number; forms: Form[] }>): void {
      const { communityId, forms } = action.payload;
      state.formsMap[communityId] = forms;
    },

    setCurrentForm(state, action: PayloadAction<Form | null>): void {
      state.currentForm = action.payload;
    },

    clearCurrentForm(state): void {
      state.currentForm = null;
    },

    updateFormResponse(state, action: PayloadAction<{ formSlug: string; response: FormResponse }>): void {
      const { formSlug, response } = action.payload;

      // Update current form if it matches
      if (state.currentForm && state.currentForm.id === formSlug) {
        const existingIndex = state.currentForm.responses.findIndex((r) => r.userId === response.userId);
        if (existingIndex >= 0) {
          state.currentForm.responses[existingIndex] = response;
        } else {
          state.currentForm.responses.push(response);
        }
      }

      // Also update in formsMap if present
      Object.keys(state.formsMap).forEach((key) => {
        const communityId = Number(key);
        const formIndex = state.formsMap[communityId]?.findIndex((f) => f.id === formSlug);
        if (formIndex !== undefined && formIndex >= 0) {
          const form = state.formsMap[communityId][formIndex];
          const existingIndex = form.responses?.findIndex((r) => r.userId === response.userId) ?? -1;
          if (existingIndex >= 0) {
            form.responses[existingIndex] = response;
          } else {
            form.responses = form.responses || [];
            form.responses.push(response);
          }
        }
      });
    },
  },
});

export const { setForms, setCurrentForm, clearCurrentForm, updateFormResponse } = formsSlice.actions;
const formsReducer = formsSlice.reducer;
export default formsReducer;
